import RouterLink from "../../components/link/RouterLink";
import StoryblokImageBasic from "../../components/storyblokImageBasic/storyblokImageBasic";
import { authorUrlFromSlug } from "../../helpers/URLHelpers";
import { SubtractSVG } from "../../svg";
import styles from "./authorCard.module.scss";

function AuthorCard({ image, name, slug, byline }) {
  return (
    <RouterLink to={authorUrlFromSlug(slug)} className={styles.root}>
      <div className={styles.imageContainer}>
        {image && image.filename ? (
          <StoryblokImageBasic
            image={image && image.filename ? image : defaultAuthorImage}
            width={190}
            height={190}
            sizes={{
              "-992": "190x190",
              "-1152": "160x160",
              "1152-": "190x190",
            }}
          />
        ) : null}
        <div className={styles.subtractSVG}>
          <SubtractSVG objectFit="contain" />
        </div>
      </div>
      <h2 className={styles.name}>{name}</h2>
      <p className={styles.byline}>{byline}</p>
    </RouterLink>
  );
}

export default AuthorCard;
